import { zodResolver } from '@hookform/resolvers/zod';
import { ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { z } from 'zod';

export const createSchema = (existingEventNames: string[], featureFlags: Record<string, boolean>) =>
  z.object({
    customEventName: z
      .string()
      .min(1, { message: 'Custom event name is required' })
      .refine(
        (value) => featureFlags.AllowCustomEventsWithDotsInSchemaManagement || !value.includes('.'),
        { message: 'Custom event name cannot contain "." characters' },
      )
      .refine((value) => !existingEventNames.includes(value), {
        message: 'Custom event with that name already exists',
      }),
  });

export type CustomEventFormStateValues = { customEventName: string };

const defaultValues = {
  customEventName: '',
};

export type CustomEventFormProviderProps = {
  children: ReactNode;
  existingEventNames: string[];
  featureFlags: Record<string, boolean>;
};

export const CustomEventFormProvider = ({
  children,
  existingEventNames,
  featureFlags,
}: CustomEventFormProviderProps) => {
  const schema = createSchema(existingEventNames, featureFlags);
  const methods = useForm<CustomEventFormStateValues>({
    defaultValues,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: zodResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
